import { BannerId } from '../../../typings/banners';
import { BannerImageForEdit } from '../../../typings/domain';
import { InternalResourceId } from '../../../typings/internalBanners';

export const UPDATE_INTERNAL_BANNER_IMAGE = 'UPDATE_INTERNAL_BANNER_IMAGE';
export type UPDATE_INTERNAL_BANNER_IMAGE = typeof UPDATE_INTERNAL_BANNER_IMAGE;
export interface UpdateInternalBannerImage {
    type: UPDATE_INTERNAL_BANNER_IMAGE;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    image: BannerImageForEdit;
}

export function updateInternalBannerImageAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    image: BannerImageForEdit
): UpdateInternalBannerImage {
    return {
        type: UPDATE_INTERNAL_BANNER_IMAGE,
        bannerId,
        resourceId,
        image
    };
}
